import { Center, Spinner } from "@chakra-ui/react";
import React from "react";

const AbsoluteLoadingOverlay = () => (
  // TODO - can Chakra do this 100%x100% overlay simpler?
  <div
    style={{
      position: "absolute",
      top: "0",
      left: "0",
      height: "100% ",
      width: "100%",
      backgroundColor: "white",
      opacity: 0.5,
    }}
  >
    <Center h={"100%"} w={"100%"}>
      <Spinner thickness="4px" speed="2s" colorScheme="gray" size="xl" />
    </Center>
  </div>
);

export default AbsoluteLoadingOverlay;
